import React from 'react';
import { useTranslation } from 'react-i18next';
import { WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import Card from '../../../../components/Card';
import ReadmoreLabel from '../../../../components/ReadmoreLabel';

import './style.scss';

interface TaxonomyExpertiseCardProps {
  title: string;
  image: React.ReactNode;
  subtitle?: string | null;
  link: string;
}

const TaxonomyExpertiseCard: React.FC<TaxonomyExpertiseCardProps> = ({
  title,
  image,
  subtitle,
  link,
}) => {
  const { t } = useTranslation();

  return (
    <Card className="TaxonomyExpertiseCard" {...link && { withLink: true }}>
      <div className="row">
        <div className="TaxonomyExpertiseCard__image col-12 col-sm-5 col-lg-5 col-xl-4">
          <Card.Image
            image={image}
          />
        </div>
        <div className="TaxonomyExpertiseCard__content col-12 col-sm-7 col-lg-6 offset-lg-1 col-xl-7 offset-xl-1">
          <Card.Title title={title} />

          {subtitle && (
            <Card.Subtitle
              subtitle={<WysiwygField className="u-truncate--3" html={subtitle} />}
            />
          )}

          <Card.Link href={link}>
            <ReadmoreLabel />
            <span className="visually-hidden">
              {t('components.read_more_label.aria_label', { title })}
            </span>
          </Card.Link>
        </div>
      </div>
    </Card>
  );
};

export default TaxonomyExpertiseCard;
